import React from 'react';
import { Phone, MessageCircle, MapPin, Instagram } from 'lucide-react';
import { restaurantInfo } from '../data/mock';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#1a1a1a] text-white">
      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-4 lg:px-8 py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="lg:col-span-2 space-y-6">
            <img
              src={restaurantInfo.logo}
              alt="Kosovalı Döner"
              className="h-16 w-auto brightness-0 invert"
              style={{ 
                imageRendering: 'auto',
                transform: 'translateZ(0)'
              }}
            />
            <p className="text-gray-400 max-w-md leading-relaxed">
              {restaurantInfo.description}
            </p>
            <div className="flex gap-4">
              <a
                href={`https://instagram.com/${restaurantInfo.instagram}`}
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-white/10 flex items-center justify-center hover:bg-[#722F37] transition-colors"
                aria-label="Instagram"
              >
                <Instagram size={18} />
              </a>
              <a
                href={`https://wa.me/${restaurantInfo.whatsapp}`}
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-white/10 flex items-center justify-center hover:bg-[#25D366] transition-colors"
                aria-label="WhatsApp"
              >
                <MessageCircle size={18} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-semibold text-lg mb-6">Hızlı Bağlantılar</h3>
            <ul className="space-y-3">
              {[
                { name: 'Ana Sayfa', href: '#home' },
                { name: 'Menü', href: '#menu' },
                { name: 'Hakkımızda', href: '#about' },
                { name: 'Galeri', href: '#gallery' },
                { name: 'İletişim', href: '#contact' }
              ].map((link) => (
                <li key={link.name}>
                  <a
                    href={link.href}
                    className="text-gray-400 hover:text-white transition-colors"
                  >
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="font-semibold text-lg mb-6">İletişim</h3>
            <ul className="space-y-4">
              <li>
                <a
                  href={`tel:${restaurantInfo.phone1.replace(/\s/g, '')}`}
                  className="flex items-center gap-3 text-gray-400 hover:text-white transition-colors"
                >
                  <Phone size={16} />
                  <span>{restaurantInfo.phone1}</span>
                </a>
              </li>
              <li>
                <a
                  href={`tel:${restaurantInfo.phone2.replace(/\s/g, '')}`}
                  className="flex items-center gap-3 text-gray-400 hover:text-white transition-colors"
                >
                  <Phone size={16} />
                  <span>{restaurantInfo.phone2}</span>
                </a>
              </li>
              <li className="flex items-start gap-3 text-gray-400">
                <MapPin size={16} className="flex-shrink-0 mt-1" />
                <span className="text-sm">{restaurantInfo.address}</span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-4 lg:px-8 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-500 text-sm">
              © {currentYear} Kosovalı Döner. Tüm hakları saklıdır.
            </p>
            <div className="flex items-center gap-6 text-sm text-gray-500">
              <span>%100 Helal</span>
              <span>•</span>
              <span>TSE Onaylı</span>
              <span>•</span>
              <span>1990'dan Beri</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;